import api from './api';

export const priceService = {
  async getPrices(params = {}) {
    const response = await api.get('/prices', { params });
    return response.data;
  },
  
  async getPriceById(id) {
    const response = await api.get(`/prices/${id}`);
    return response.data;
  },
  
  async createPrice(priceData) {
    const response = await api.post('/prices', priceData);
    return response.data;
  },
  
  async updatePrice(id, priceData) {
    const response = await api.put(`/prices/${id}`, priceData);
    return response.data;
  },
  
  async deletePrice(id) {
    const response = await api.delete(`/prices/${id}`);
    return response.data;
  },
  
  async getPricesByCarrier(carrierId, params = {}) {
    const response = await api.get(`/prices/carrier/${carrierId}`, { params });
    return response.data;
  },
  
  async calculatePrice(params) {
    const response = await api.get('/prices/calculate', { params });
    return response.data;
  },
  
  async bulkUpdatePrices(pricesData) {
    const response = await api.post('/prices/bulk', pricesData);
    return response.data;
  }
};
